import { useState } from 'react';
import { trpc } from '../../api/trpc';
import { useDialogClose } from '../../hooks/useDialogClose';

interface Props {
  onClose: () => void;
  onCreated: (agentId: string) => void;
}

export function CreateAgentDialog({ onClose, onCreated }: Props) {
  const { isClosing, handleClose } = useDialogClose(onClose);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [prompt, setPrompt] = useState('');
  const utils = trpc.useUtils();

  const createMutation = trpc.taskAgents.agentCreate.useMutation({
    onSuccess: (data) => {
      void utils.taskAgents.agentList.invalidate();
      onCreated(data.id);
    },
  });

  function handleSubmit() {
    if (!name.trim() || !prompt.trim()) return;
    createMutation.mutate({
      name: name.trim(),
      description: description.trim() || undefined,
      prompt: prompt.trim(),
    });
  }

  return (
    <div className={`agent-dialog-overlay${isClosing ? ' overlay-closing' : ''}`} onClick={handleClose}>
      <div className={`agent-dialog${isClosing ? ' dialog-closing' : ''}`} onClick={(e) => e.stopPropagation()}>
        <div className="agent-dialog-title">Create Task Agent</div>

        <div className="agent-field">
          <label>Name</label>
          <input
            type="text"
            placeholder="e.g., Compromised Account Investigation"
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoFocus
          />
        </div>

        <div className="agent-field">
          <label>Description</label>
          <input
            type="text"
            placeholder="Brief description of what this agent does"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>

        <div className="agent-field">
          <label>Prompt</label>
          <textarea
            placeholder="Write the agent's instructions. Use {parameter_name} for variable values."
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
          />
        </div>

        <div className="agent-dialog-actions">
          <button
            style={{ padding: '8px 16px', borderRadius: 'var(--radius)', border: '1px solid var(--color-border)', cursor: 'pointer', fontFamily: 'var(--font-sans)', fontSize: '13px', background: 'var(--color-surface)', color: 'var(--color-text-primary)' }}
            onClick={handleClose}
          >
            Cancel
          </button>
          <button
            className="btn-primary"
            style={{ padding: '8px 16px', fontSize: '13px' }}
            onClick={handleSubmit}
            disabled={!name.trim() || !prompt.trim() || createMutation.isPending}
          >
            {createMutation.isPending ? 'Creating...' : 'Create Agent'}
          </button>
        </div>
      </div>
    </div>
  );
}
